/**
 * The wording of a matter's business-ledger balance in the reader's dialect
 * ("Due by client for this matter" / "Due to client for this matter", or
 * "...for this project"). The direction comes from the client position, so the
 * label and the non-negative figure beside it always agree.
 */
export function describeMatterPositionLabel(copy, position) {
    return copy(position.inCredit ? 'hub:clientStatementMatter.matterDueToClient' : 'hub:clientStatementMatter.matterDueByClient');
}
/**
 * The wording of an unpaid invoices statement's final figure in the reader's
 * dialect. A client total carries its own fixed label; a matter total is the
 * sum of open invoices, never a credit, so it reads as the matter's "due by".
 */
export function describeUnpaidInvoicesTotalLabel(copy, total) {
    return total.kind === 'matter' ? describeMatterPositionLabel(copy, { inCredit: false }) : total.label;
}
